/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

'use strict';

class DateEx extends Date {
    dateParse () {
        //console.log(this.getHours());
        const yyyy = `${this.getFullYear()}`;
        // .slice(-2)で文字列中の末尾の2文字を取得する
        // `0${date.getHoge()}`.slice(-2) と書くことで０埋めをする
        const MM = `0${this.getMonth() + 1}`.slice(-2); // getMonth()の返り値は0が基点
        const dd = `0${this.getDate()}`.slice(-2);
        const HH = `0${this.getHours()}`.slice(-2);
        const mm = `0${this.getMinutes()}`.slice(-2);
        const ss = `0${this.getSeconds()}`.slice(-2);
        const dow = this.getDay();

        return {
            year: yyyy,
            month: MM,
            day: dd,
            hour: HH,
            minute: mm,
            second: ss,
            dayofweek: dow,
        };
    }
    format () {
        const info = this.dateParse();
        return `${info.year}-${info.month}-${info.day} ${info.hour}:${info.minute}:${info.second}`;
    }
}

export {DateEx};
